"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Dealsheet = void 0;
const typebox_1 = require("@sinclair/typebox");
const common_1 = require("../common");
exports.Dealsheet = typebox_1.Type.Object({
    id: typebox_1.Type.String(),
    name: typebox_1.Type.String(),
    dealsheetNumber: typebox_1.Type.Number(),
    status: typebox_1.Type.Optional(typebox_1.Type.String()),
    accountRepId: typebox_1.Type.Optional(typebox_1.Type.String()),
    contractEndDate: typebox_1.Type.Optional(typebox_1.Type.String({ format: 'date-time' })),
    proposalNumbers: typebox_1.Type.Array(typebox_1.Type.Number()),
    metadata: common_1.MetaData,
});
//# sourceMappingURL=dealsheet-transport.js.map